/* ═══════════════════════════════════════════════════
   PopArto Theme – JavaScript (Full Functionality)
   ═══════════════════════════════════════════════════ */

var _scrollLocks = 0;

function lockScroll() {
  _scrollLocks++;
  if (_scrollLocks !== 1) return;
  document.documentElement.style.overflow = 'hidden';
  document.body.style.overflow = 'hidden';
}

function unlockScroll() {
  _scrollLocks = Math.max(0, _scrollLocks - 1);
  if (_scrollLocks !== 0) return;
  document.documentElement.style.overflow = '';
  document.body.style.overflow = '';
}

(function () {
  'use strict';

  /* ═══════════ HELPERS ═══════════ */

  function fetchJSON(url, options) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } }, options))
      .then(function (r) { return r.json(); });
  }

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.theme_money_format || '₹{{amount}}');
    }
    return '₹' + (cents / 100).toFixed(2);
  }

  function updateCartCount(count) {
    document.querySelectorAll('.site-header__cart-count').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
    document.querySelectorAll('.cart-drawer__title').forEach(function (el) {
      el.textContent = 'Cart (' + count + ')';
    });
  }

  /* ═══════════ MOBILE MENU ═══════════ */

  var menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  var menuClose = document.querySelector('[data-mobile-menu-close]');
  var menuPanel = document.querySelector('[data-mobile-menu]');
  var menuOverlay = document.querySelector('[data-mobile-menu-overlay]');

  function openMenu() {
    if (!menuPanel) return;
    if (menuPanel.classList.contains('is-open')) return; /* already open — don't double-lock */
    menuPanel.classList.add('is-open');
    menuOverlay && menuOverlay.classList.add('is-open');
    lockScroll();
  }
  function closeMenu() {
    if (!menuPanel) return;
    if (!menuPanel.classList.contains('is-open')) return; /* already closed */
    menuPanel.classList.remove('is-open');
    menuOverlay && menuOverlay.classList.remove('is-open');
    unlockScroll();
  }

  menuToggle && menuToggle.addEventListener('click', openMenu);
  menuClose && menuClose.addEventListener('click', closeMenu);
  menuOverlay && menuOverlay.addEventListener('click', closeMenu);

  /* ═══════════ CART DRAWER ═══════════ */

  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOverlay = document.querySelector('[data-cart-overlay]');
  var cartClose = document.querySelector('[data-cart-close]');

  function openCart() {
    if (!cartDrawer) return;
    if (cartDrawer.classList.contains('is-open')) return; /* already open — don't double-lock */
    cartDrawer.classList.add('is-open');
    cartOverlay && cartOverlay.classList.add('is-open');
    lockScroll();
  }
  function closeCart() {
    if (!cartDrawer) return;
    if (!cartDrawer.classList.contains('is-open')) return; /* already closed */
    cartDrawer.classList.remove('is-open');
    cartOverlay && cartOverlay.classList.remove('is-open');
    unlockScroll();
  }

  /* Refresh cart drawer HTML after AJAX changes — returns a Promise */
  function refreshCartDrawer() {
    return fetch('/?sections=cart-drawer-v2')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer-v2'];
        if (!html) return;
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var newDrawer = temp.querySelector('[data-cart-drawer]');
        if (newDrawer && cartDrawer) {
          cartDrawer.innerHTML = newDrawer.innerHTML;
          var newClose = cartDrawer.querySelector('[data-cart-close]');
          newClose && newClose.addEventListener('click', closeCart);
          initQuantitySelectors(cartDrawer);
          initCartRemoveLinks(cartDrawer);
        }
      });
  }

  /* Add multiple items to cart, refresh drawer, then open — used by cross-sell handler */
  function addItemsToCart(items) {
    /* Filter out any items with invalid/missing variant IDs */
    items = items.filter(function(item) {
      return item.id && !isNaN(item.id) && item.id > 0;
    });
    if (!items.length) return Promise.resolve();

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(r) {
      return r.json().then(function(data) {
        if (!r.ok) {
          /* Cart add failed (e.g. variant unavailable) — try adding just the main product */
          console.warn('Cart add failed:', data.description || data);
          var mainItem = items[0];
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [mainItem] })
          }).then(function(r2) { return r2.json(); });
        }
        return data;
      });
    })
    .then(function() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      updateCartCount(cart.item_count);
      /* Use PopArtoCart.reload (section's own reliable method) if available */
      if (window.PopArtoCart && typeof window.PopArtoCart.reload === 'function') {
        return window.PopArtoCart.reload();
      }
      return refreshCartDrawer();
    })
    .then(function() {
      /* Use PopArtoCart.open if available, otherwise fall back */
      if (window.PopArtoCart && typeof window.PopArtoCart.open === 'function') {
        window.PopArtoCart.open();
      } else {
        openCart();
      }
    });
  }

  /* Expose cart helpers globally */
  window.openCartDrawer    = openCart;
  window.refreshCartDrawer = refreshCartDrawer;
  window.updateCartCount   = updateCartCount;
  window.addItemsToCart    = addItemsToCart;

  document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  });
  cartClose && cartClose.addEventListener('click', closeCart);
  cartOverlay && cartOverlay.addEventListener('click', closeCart);

  /* ═══════════ AJAX ADD TO CART ═══════════ */

  function addToCart(variantId, quantity) {
    return fetchJSON('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
    }).then(function () {
      return fetchJSON('/cart.js').then(function (cart) {
        updateCartCount(cart.item_count);
        refreshCartDrawer();
        openCart();
        return cart;
      });
    });
  }

  /* ═══════════ AJAX CART UPDATE ═══════════ */

  function updateCartItem(key, quantity) {
    return fetchJSON('/cart/change.js', {
      method: 'POST',
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (cart) {
      updateCartCount(cart.item_count);
      refreshCartDrawer();
      if (document.querySelector('.main-cart')) {
        location.reload();
      }
      return cart;
    });
  }

  /* ═══════════ CART REMOVE LINKS (AJAX) ═══════════ */

  function initCartRemoveLinks(scope) {
    (scope || document).querySelectorAll('.cart-drawer__remove, .main-cart__remove').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var url = new URL(link.href, window.location.origin);
        var id = url.searchParams.get('id');
        if (id) updateCartItem(id, 0);
      });
    });
  }
  initCartRemoveLinks();

  /* ═══════════ QUANTITY SELECTORS ═══════════ */

  function initQuantitySelectors(scope) {
    (scope || document).querySelectorAll('[data-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentElement.querySelector('[data-qty-input]');
        if (input && parseInt(input.value) > 1) {
          input.value = parseInt(input.value) - 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
    (scope || document).querySelectorAll('[data-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentElement.querySelector('[data-qty-input]');
        if (input) {
          input.value = parseInt(input.value) + 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }
  initQuantitySelectors();

  /* ═══════════ DESKTOP DROPDOWN NAV ═══════════ */

  document.querySelectorAll('[data-dropdown]').forEach(function (dropdown) {
    var timeout;
    dropdown.addEventListener('mouseenter', function () {
      clearTimeout(timeout);
      dropdown.classList.add('is-open');
    });
    dropdown.addEventListener('mouseleave', function () {
      timeout = setTimeout(function () { dropdown.classList.remove('is-open'); }, 150);
    });
  });

  /* ═══════════ MOBILE ACCORDION NAV ═══════════ */

  document.querySelectorAll('[data-accordion-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = document.getElementById(btn.getAttribute('aria-controls'));
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', !expanded);
      if (target) {
        target.style.maxHeight = expanded ? '0' : target.scrollHeight + 'px';
      }
    });
  });

  /* ═══════════ REVIEW CAROUSEL ═══════════ */

  var reviewSection = document.querySelector('[data-reviews]');
  if (reviewSection) {
    var slides = reviewSection.querySelectorAll('[data-review-slide]');
    var counter = reviewSection.querySelector('[data-review-counter]');
    var current = 0;

    function showSlide(i) {
      slides.forEach(function (s, idx) { s.style.display = idx === i ? '' : 'none'; });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
    }

    var prevBtn = reviewSection.querySelector('[data-review-prev]');
    var nextBtn = reviewSection.querySelector('[data-review-next]');
    prevBtn && prevBtn.addEventListener('click', function () {
      current = current === 0 ? slides.length - 1 : current - 1;
      showSlide(current);
    });
    nextBtn && nextBtn.addEventListener('click', function () {
      current = current === slides.length - 1 ? 0 : current + 1;
      showSlide(current);
    });
    showSlide(0);
  }

  /* ═══════════ QUICK ADD TO CART ═══════════ */

  document.querySelectorAll('.product-card__quick-add').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = btn.getAttribute('data-product-id');
      if (variantId) {
        btn.classList.add('is-loading');
        addToCart(parseInt(variantId), 1).finally(function () {
          btn.classList.remove('is-loading');
        });
      }
    });
  });

  /* ═══════════ PRODUCT PAGE: GALLERY ═══════════ */

  var gallery = document.querySelector('[data-product-gallery]');
  if (gallery) {
    var gallerySlides = gallery.querySelectorAll('[data-gallery-slide]');
    var galleryThumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var currentSlide  = 0;

    function showGallerySlide(index) {
      index = Math.max(0, Math.min(index, gallerySlides.length - 1));
      currentSlide = index;
      gallerySlides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === index);
      });
      galleryThumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === index);
      });
    }

    galleryThumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showGallerySlide(parseInt(thumb.getAttribute('data-gallery-thumb')));
      });
    });

    /* ── Touch swipe on mobile ── */
    var galleryMain = gallery.querySelector('[data-gallery-main]');
    if (galleryMain) {
      var touchStartX = 0;
      var touchStartY = 0;
      var swipeLocked = false;

      galleryMain.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        swipeLocked = false;
      }, { passive: true });

      galleryMain.addEventListener('touchend', function (e) {
        if (swipeLocked) return;
        var dx = e.changedTouches[0].clientX - touchStartX;
        var dy = e.changedTouches[0].clientY - touchStartY;
        /* Only trigger if horizontal swipe is dominant and at least 40px */
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        if (dx < 0) {
          showGallerySlide(currentSlide + 1); /* swipe left → next */
        } else {
          showGallerySlide(currentSlide - 1); /* swipe right → prev */
        }
      }, { passive: true });

      /* Lock swipe if the user is clearly scrolling vertically */
      galleryMain.addEventListener('touchmove', function (e) {
        var dy = Math.abs(e.touches[0].clientY - touchStartY);
        var dx = Math.abs(e.touches[0].clientX - touchStartX);
        if (dy > dx) swipeLocked = true;
      }, { passive: true });
    }
  }

  /* ═══════════ PRODUCT PAGE: VARIANT SWITCHING ═══════════ */

  var variantSelector = document.querySelector('[data-variant-selector]');
  var productJsonEl = document.querySelector('[data-product-json]');

  if (variantSelector && productJsonEl) {
    var variants = JSON.parse(productJsonEl.textContent);

    function getSelectedOptions() {
      var options = [];
      variantSelector.querySelectorAll('fieldset').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) options.push(checked.value);
      });
      return options;
    }

    function findVariant(options) {
      return variants.find(function (v) {
        return options.every(function (opt, i) { return v.options[i] === opt; });
      });
    }

    function onVariantChange() {
      var options = getSelectedOptions();
      var variant = findVariant(options);
      if (!variant) return;

      var idInput = document.querySelector('[data-variant-id]');
      if (idInput) idInput.value = variant.id;

      var priceEl = document.querySelector('[data-price]');
      var compareEl = document.querySelector('[data-compare-price]');
      var badgeEl = document.querySelector('[data-save-badge]');
      var stickyPriceEl = document.querySelector('[data-sticky-price]');

      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(variant.price);

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (compareEl) { compareEl.textContent = formatMoney(variant.compare_at_price); compareEl.style.display = ''; }
        if (badgeEl) {
          var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
          badgeEl.textContent = 'Save ' + pct + '%';
          badgeEl.style.display = '';
        }
      } else {
        if (compareEl) compareEl.style.display = 'none';
        if (badgeEl) badgeEl.style.display = 'none';
      }

      var addBtn = document.querySelector('[data-add-to-cart]');
      var addText = document.querySelector('[data-add-to-cart-text]');
      var stickyBtn = document.querySelector('[data-sticky-add-btn]');
      if (variant.available) {
        if (addBtn) addBtn.disabled = false;
        if (addText) addText.textContent = 'Add to Cart';
        if (stickyBtn) stickyBtn.disabled = false;
      } else {
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = 'Sold Out';
        if (stickyBtn) stickyBtn.disabled = true;
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState(null, '', url.toString());

      if (variant.featured_image && gallery) {
        var slides = gallery.querySelectorAll('[data-gallery-slide]');
        slides.forEach(function (slide, i) {
          var img = slide.querySelector('img');
          if (img && variant.featured_image.src && img.src.indexOf(variant.featured_image.id) > -1) {
            showGallerySlide(i);
          }
        });
      }
    }

    variantSelector.querySelectorAll('input[type="radio"]').forEach(function (input) {
      input.addEventListener('change', onVariantChange);
    });
  }

  /* ═══════════ PRODUCT PAGE: ADD TO CART FORM ═══════════ */

  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      /* If accessories are checked, let the cross-sell handler in main-product.liquid take over */
      var checkedCrossSells = document.querySelectorAll('[data-cross-sell-check]:checked');
      if (checkedCrossSells.length > 0) return;

      e.preventDefault();
      var variantId = productForm.querySelector('[data-variant-id]');
      var qtyInput = productForm.querySelector('[data-qty-input]');
      if (!variantId) return;

      var addBtn = productForm.querySelector('[data-add-to-cart]');
      var addText = productForm.querySelector('[data-add-to-cart-text]');
      if (addBtn) addBtn.disabled = true;
      if (addText) addText.textContent = 'Adding...';

      addToCart(parseInt(variantId.value), parseInt(qtyInput ? qtyInput.value : 1))
        .then(function () {
          if (addText) addText.textContent = 'Added!';
          setTimeout(function () {
            if (addText) addText.textContent = 'Add to Cart';
            if (addBtn) addBtn.disabled = false;
          }, 1500);
        })
        .catch(function () {
          if (addText) addText.textContent = 'Add to Cart';
          if (addBtn) addBtn.disabled = false;
        });
    });
  }

  /* ═══════════ PRODUCT PAGE: STICKY ADD TO CART ═══════════ */

  var stickyAtc = document.querySelector('[data-sticky-atc]');
  var mainAddBtn = document.getElementById('main-add-to-cart') || document.querySelector('[data-add-to-cart]');

  if (stickyAtc && mainAddBtn) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyAtc.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(mainAddBtn);

    var stickyBtn = stickyAtc.querySelector('[data-sticky-add-btn]');
    if (stickyBtn && productForm) {
      stickyBtn.addEventListener('click', function () {
        productForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
    }
  }

  /* ═══════════ PRODUCT PAGE: TABS ═══════════ */

  var tabsContainer = document.querySelector('[data-product-tabs]');
  if (tabsContainer) {
    var tabBtns = tabsContainer.querySelectorAll('[data-tab-btn]');
    var tabPanels = tabsContainer.querySelectorAll('[data-tab-panel]');

    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-tab-btn');
        tabBtns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        tabPanels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-tab-panel') === target); });
      });
    });
  }

  /* ═══════════ COLLECTION PAGE: SORT ═══════════ */

  var sortSelect = document.querySelector('[data-collection-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* ═══════════ CART PAGE: QTY CHANGE ═══════════ */

  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    cartForm.querySelectorAll('[data-qty-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        cartForm.submit();
      });
    });
  }

})();